import { AuthUser, HttpMethod } from '@aibees/shared/definition';
import { baseQueryClient } from '@aibees/shared/http/base-query-client';
import { useBaseMutation } from '@aibees/shared/http/hooks';
import {
  useCreateWorkspaceMutationApi,
  useUpdateWorkspace,
} from '@aibees/shared/workspace';
import { useUserProfileApi } from './use-user-profile-api';

export function useUserEditMutationApi() {
  const refreshWorkspace = useCreateWorkspaceMutationApi();
  const updateWorkspace = useUpdateWorkspace();

  return useBaseMutation<AuthUser, AuthUser>(
    {
      url: '/customer-management/um/users/profile',
      method: HttpMethod.put,
    },

    {
      onSuccess: (data) => {
        baseQueryClient.invalidateQueries([useUserProfileApi.name]);
        refreshWorkspace
          .mutateAsync({ name: `${data.firstName}-${data.lastName}` })
          .then(updateWorkspace)
          .catch(() => undefined);
      },
    }
  );
}
